import { Routes } from '@angular/router';

export const profileRoutes: Routes = [
  {
    path: 'profile',
    loadComponent: () =>
      import('./page/profile-page/profile-page.component').then((m) => m.ProfilePageComponent),
  },
];
